import React from 'react'
import { Container, Embed } from 'semantic-ui-react';

const VideoSection = () => (
  <div style={styles.root} className='Tile'>
    <Container>
      <h1 style={styles.titleText}>Check our videos</h1>
      <br/><br/>
      <Embed
        id='ag1OqlUZM60'
        // placeholder='/images/image-16by9.png'
        source='youtube'
      />
    </Container>
  </div>
)

const styles = {
  root: {
    // backgroundColor: 'black',
    paddingTop: '100px',
    paddingBottom: '100px'
  },
  titleText: {
    fontSize: '70px',
    fontStyle: 'italic',
    color: '#fff'
  }
}

export {VideoSection};